<template>
  <field-layout :content="content">
    <image-upload-and-crop v-bind="imageEdit" :allow-external-image="allowExternalImage"
                           :external-image-attribution-unsplash-url="externalImageAttributionUnsplashUrl"
                           :external-image-attribution-utm-params="externalImageAttributionUtmParams"
                           :external-image-photo-retrieval-url-with-placeholder="externalImagePhotoRetrievalUrlWithPlaceholder"
                           :external-image-search-url="externalImageSearchUrl"
                           entity-type="event" />
  </field-layout>
</template>

<script>
import FieldLayout from '@/campaign-form-shared/field-layout'
import FieldMixin from '@/campaign-form-shared/field-mixin'
import ImageUploadAndCrop from '../../image/upload-and-crop'
import { mapState } from 'vuex'

export default {
  components: { FieldLayout, ImageUploadAndCrop },

  mixins: [ FieldMixin ],

  computed: {
    ...mapState(['imageEdit', 'externalImageAttributionUnsplashUrl', 'externalImageAttributionUtmParams',
                 'externalImagePhotoRetrievalUrlWithPlaceholder', 'externalImageSearchUrl']),

    allowExternalImage() {
      return this.agraConfiguration.externalImagesEnabled
    }
  }
}
</script>
